import React, { useState, useEffect, useRef } from "react";
// import "./../../About/OurStory/OurStory.css";
import "./AccountClosure.css";
import { Container, Col, Row } from "react-bootstrap";
import LoginPopup from "../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../features/User/UserSlice';
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";

function AccountClosure() {
  let navigate = useNavigate();
  const [check, setChecked] = useState();
  const [show, setShow] = useState(false);
  const childRef = useRef(null);
  const dispatch = useDispatch();
  const handleShow = () => setShow(true);
  const handleClose = () => setShow();
  const usrname = useSelector(state => state.user.email);
  const { isFetching, isSuccess, isError, errorMessage, isCRMuser } = useSelector(
    userSelector
  );
  useEffect(() => {
    if (isSuccess) {
      setShow(false);
    }
    if (isError) {

      //console.log(errorMessage);
      dispatch(clearState());
    }
  }, [isSuccess, isError]);

  const onSubmit = (event) => {
    event.preventDefault()
    if (check) {
      clickToggleLoginPopup(true)
    }
    else {
      alert("Please accepted Privacy Policies and Terms and Conditions");

    }
  }


  const ClickCheckBox = (evt) => {
    setChecked(evt.target.checked)
  }
  const handleClosePopup = () => {
    handleClose(true);
  }

  const clickToggleLoginPopup = (showhide) => {
    if (isSuccess) {
      if (isCRMuser) {
        navigate('/AccountClosureOption');
      }
      else {
        handleShow();
      }

    }
    else {
      childRef.current.changeTogglePopup(showhide);
    }
  }

  return (
    <>
      <div className="accountClosure_page">
        <section className="our-story-block disclaimer">
          <Container>
            <Row>
              <Col md={{ span: 12, offset: 0 }}>
                <div className="our-story-inner arrow-main">
                  <h2>How To Close Moneysukh Account</h2>
                  <p>
                    If you are not using your Demat & Trading account for long, but still keep getting charged yearly fees. It is better to close all your inactive or zero balance account. It attracts annual fees and maintenance charges. Thus, if there are active balances, they can be consolidated into one account and the remaining redundant accounts can be closed.
                  </p>

                  <h3>Details Required for closing a demat account </h3>
                  <p>You need to include the following details while submitting your closure form:</p>
                  <h3>DP and client ID </h3>
                  <p>KYC details like name and address. These should be in line with the records.</p>
                  <h3>Reason for closing the Demat account. </h3>
                  <p>Is there more than one person holding the Demat account? Then, all holders must sign the closure form.</p>
                  <h3>Closing a demat account procedure </h3>

                  <p>You can download the form Fill and upload scan copy of Downloaded Form.</p>

                  <h3>Ensure that there are no shares in the account </h3>
                  <p>To close your account, the foremost thing is to ensure whether there are any shares in the account. If there are, you need to transfer them to another account. You need to make sure your Demat account is empty before you can decide to close it.</p>
                  <h3>No negative cash balance </h3>
                  <p>Negative cash balance can increase due to the non-payment of annual maintenance fees or any other charges. If you request an account closure without settling your account, your application will be rejected.</p>
                  <h3>Submit the application </h3>
                  <p>You should mention the details of the new depository account if any and a few other details. Once the request is successfully submitted, the depository takes nearly 4-6 working days to complete the procedure.</p>

                  <div className="accountcloser_termtext">
                    <form onSubmit={onSubmit}>
                      <div className="custom-control custom-checkbox mb-3">
                        <input type="checkbox" className="custom-control-input" id="customCheck" name="example1" value={ClickCheckBox} onClick={ClickCheckBox}></input>
                        <label className="custom-control-label" htmlFor="customCheck">I agree that I have read and accepted  Privacy Policies and Terms and Conditions Agreements</label>

                        <br />
                        {check == true ?
                          <button type="submit" className="btn btn-primary btn-lg mt-2">Continue</button> :
                          <button type="submit" className="btn btn-primary btn-lg mt-2" disabled>Continue</button>
                        }
                      </div>
                      <Modal className="success-modal account-closure-modal" show={show} >
                        <Modal.Body className="textsucess"> Looks like your details are not registered with us ! Please call our Customer Support division for any further assistance.</Modal.Body>
                        <button className="btnClose" onClick={handleClosePopup}>Close</button>
                      </Modal>
                    </form>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <LoginPopup show={show} ref={childRef} />
        </section>

      </div>
    </>
  );
}
export default AccountClosure;
